// extracted by mini-css-extract-plugin
module.exports = {"form":"popup-form-module--form--2yOyW","submit":"popup-form-module--submit--1JvaX","selectWrap":"popup-form-module--selectWrap--1mt6k","select":"popup-form-module--select--1HgAF"};